import React from "react";
import {
    SCHEDULES_REPORT_LAYOUT_LABELS,
    SchedulesReportLayout,
} from "@common/types/reports/schedules-report";
import { Picker } from "@design-system/Picker/Picker.lib";
import type { PickerItemData } from "@design-system/Picker/Picker.types";

interface Props {
    value: SchedulesReportLayout;
    onChange: (layout: SchedulesReportLayout) => void;
}

const LAYOUT_ITEMS: Array<PickerItemData<SchedulesReportLayout>> =
    Object.values(SchedulesReportLayout).map((option) => ({
        value: option,
        label: SCHEDULES_REPORT_LAYOUT_LABELS[option],
    }));

export const SchedulesReportLayoutSelect: React.FC<Props> = ({
    value,
    onChange,
}) => (
    <Picker.Select
        items={LAYOUT_ITEMS}
        value={value}
        onValueChange={(next) => {
            if (next) {
                onChange(next);
            }
        }}
    />
);
